import { useEffect, useState, useRef } from 'react';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EFAppArrow from '@/components/UI/svg/Icons/EFAppArrow';
import EFVideo from '@/components/UI/EFVideo';
import { createEFPic } from '@/utils/useEFPic';
const { EFPic } = createEFPic('/media/mh200/');

function isContain(selector: string, offsetNum = 0) {
    const dom = document.querySelector(selector) as HTMLElement;
    if (!dom) {
        return false;
    }
    const totalHeight = window.innerHeight || document.documentElement.clientHeight;
    const { top } = dom.getBoundingClientRect();
    //刚进入可视区
    return top >= 0 && top <= totalHeight - offsetNum;
}

export default function MhTextC({}: any) {
    const { useLang, useRouter, isMobile, Link } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('waveportableairconditioner');
    let controller: any;
    const [isEnterA1, setIsEnterA1] = useState(false);
    const videoRef = useRef(null);
    const video2Ref = useRef(null);
    const appRedirct = ['us', 'ca', 'uk', 'au', 'de', 'fr', 'jp'];

    const imgExtMap: any = {
        us: 'fahrenheit',
        jp: 'celsius',
        cn: 'celsius',
        au: 'celsius',
        ca: 'celsius',
        za: 'celsius',
        sa: 'celsius',
    };
    const imgLocal = imgExtMap[locale] || imgExtMap['us'];
    const videoPath1 = isMobile
        ? ['/video/Mh200/productJ1_h5.webm', '/video/Mh200/productJ1_h5.mp4']
        : ['/video/Mh200/productJ1.webm', '/video/Mh200/productJ1.mp4'];
    const videoPath2 = [
        `/video/Mh200/productJ2_${imgLocal}_${isMobile ? 'h5' : 'pc'}.webm`,
        `/video/Mh200/productJ2_${imgLocal}_${isMobile ? 'h5' : 'pc'}.mp4`,
    ];

    const appImageExtMap: { [key: string]: string } = {
        us: 'en',
        jp: 'au',
        cn: 'cn',
        au: 'au',
        ca: 'au',
        za: 'za',
        sa: 'au',
    };
    const appImgLocal = appImageExtMap[locale] || appImageExtMap['us'];

    useEffect(() => {
        controller = new ScrollMagic.Controller();
    }, []);

    useEffect(() => {
        //只有桌面端才有该动画哦
        if (!isMobile) {
            const sceneA1 = new ScrollMagic.Scene({
                triggerElement: '.mhTextC',
                offset: 200,
                triggerHook: 0.5, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
                duration: '200%',
            });

            sceneA1.on('enter', function () {
                setIsEnterA1(true);
            });
            sceneA1.on('leave', function () {
                setIsEnterA1(false);
            });

            controller.addScene(sceneA1);
        }
    }, []);

    const replayVideo2 = () => {
        try {
            video2Ref.current?.play();
        } catch (e: any) {}
    };

    // a-播放视频
    const addVideoCallbackA2 = () => {
        if (isContain('.mhTextC .img-box', 100)) {
            try {
                videoRef.current?.play();
            } catch (e: any) {}
            isMobile && replayVideo2();
            window.removeEventListener('scroll', addVideoCallbackA2);
        }
    };

    useEffect(() => {
        window.addEventListener('scroll', addVideoCallbackA2);
    }, []);

    return (
        <div className={`${css.mhTextC} mhTextC ${isMobile ? 'mhTextC-h5' : 'mhTextC-pc'}`}>
            <div className="item-box item-box1">
                <div className="img-box">
                    <EFVideo ref={videoRef} className="video" sources={videoPath1} />
                </div>
                <div className="ms-box ms-box1">
                    <div className="msg-a-title1">{t('mh200.mhTC_ms1')}</div>
                    <div className="msg-a-title2">{t('mh200.mhTC_ms2')}</div>
                    <div className="msg-a-title3">{t('mh200.mhTC_ms3')}</div>
                </div>
            </div>
            <div className={`list-box-out ${isEnterA1 ? 'isEnterA1' : ''}`}>
                <div className="list-box">
                    <div className="item-box item-box2">
                        <div className="img-box">
                            <EFVideo ref={video2Ref} className="video" sources={videoPath2} />
                        </div>
                        <div className="ms-box ms-box2">
                            <div className="msg-a-title1">{t('mh200.mhTC_ms4')}</div>
                            <div className="msg-a-title2">{t('mh200.mhTC_ms5')}</div>
                            <div className="msg-a-title3">{t('mh200.mhTC_ms6')}</div>
                        </div>
                    </div>
                    <div className="item-box item-box3">
                        {!isMobile && (
                            <div className="img-box">
                                <EFPic name={[`pc/productJ3_${appImgLocal}.webp`, `pc/productJ3_${appImgLocal}.png`]} alt="" />
                            </div>
                        )}
                        {isMobile && (
                            <div className="img-box">
                                <EFPic name={[`h5/productA3_${appImgLocal}.webp`, `h5/productA3_${appImgLocal}.jpg`]} className="fullImgs" alt="" />
                            </div>
                        )}
                        <div className="ms-box ms-box3">
                            <div className="msg-a-title2">{t('mh200.mhTC_ms7')}</div>
                            <div className="msg-a-title3">{t('mh200.mhTC_ms8')}</div>
                            {appRedirct.includes(locale) && (
                                <div className="learn">
                                    <Link href="/app" className="link_learn" newWin>
                                        <div className="text">{t('mh200.learn_more')}</div>
                                        <div className="icon">
                                            <EFAppArrow />
                                        </div>
                                    </Link>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            <div className="item-box item-box4">
                <div className="img-box img-box4">
                    <EFPic
                        name={[`${isMobile ? 'h5/' : 'pc/'}box_${imgLocal}.webp`, `${isMobile ? 'h5/' : 'pc/'}box_${imgLocal}.jpg`]}
                        className="fullImgs"
                        alt="EcoFlow MH200"
                    />
                </div>
                <div className="ms-box ms-box4">
                    <div className="msg-a-title4">{t('mh200.mhTC_ms9')}</div>
                </div>
            </div>
        </div>
    );
}
